import React, { useEffect } from 'react'
import { Col } from 'react-bootstrap'
import { connect } from 'react-redux'
import DatePicker from '../../../LaridaeApp/datepicker/container/DatePicker'
import { getEstadisticasVolcadoras, obtenerDemorasEnVolcadoras, obtenerMotivosDemoraEnVolcadora, obtenerVolcadorasCamiones } from '../../actions/EstadisticasVolcadorasActions'
import EstadisticasVolcadorasView from '../../components/estadisticasVolcadoras/EstadisticasVolcadorasView'
import DemoraEnVolcadorasView from '../../components/estadisticasVolcadoras/DemoraEnVolcadorasView'

function EstadisticasVolcadoras (props) {
  useEffect(() => {
    props.getEstadisticasVolcadoras(new Date(), new Date())
    props.obtenerDemorasEnVolcadoras(new Date(), new Date())
    props.obtenerMotivosDemoraEnVolcadora()
    props.obtenerVolcadorasCamiones()
  })

  const actualizarfechas = (fechaD, fechaH) => {
    props.getEstadisticasVolcadoras(fechaD, fechaH)
    props.obtenerDemorasEnVolcadoras(fechaD, fechaH)
  }

  return (
    <>
      <h2>Estadísticas de volcadoras</h2>

      <Col md={4} style={{ margin: '12px auto' }}>
        <DatePicker
          style={{ width: '95%' }}
          disabledFuture
          selectRange
          locale='es'
          onDateChange={actualizarfechas}
          titulo='Seleccione las fechas'
        />
      </Col>

      <div style={{ margin: '2% 0' }}>
        <EstadisticasVolcadorasView />
      </div>

      <div style={{ margin: '2% 0' }}>
        <DemoraEnVolcadorasView />
      </div>
    </>
  )
}

const mapActionsToProps = {
  getEstadisticasVolcadoras,
  obtenerDemorasEnVolcadoras,
  obtenerMotivosDemoraEnVolcadora,
  obtenerVolcadorasCamiones
}

const withRedux = connect(null, mapActionsToProps)
export default withRedux(EstadisticasVolcadoras)
